// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/frameHeader/stylesheet/header.scss
 ** module id = 436
 ** module chunks = 1
 **/